module.exports = __webpack_public_path__ + "media/images/lb/323-cc7dcc2aa1be377341148d40af26eedd.svg";